import { queryOptions } from '@tanstack/react-query';
import RequestNotFoundError from '../../errors/RequestNotFoundError';
import { getRequestQuery } from './get-request-query';

export const getRequestQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [getRequestQuery(id).className, getRequestQuery(id).toJSON()],
    queryFn: async () => {
      const query = getRequestQuery(id);
      const result = await query.first();
      if (!result) {
        throw new RequestNotFoundError(id);
      }
      return result;
    },
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
